import { gql } from "@apollo/client";

// Query to fetch all holidays for a specific business
export const GET_BUSINESS_HOLIDAYS = gql`
  query getBusinessHolidays($businessId: Int!) {
    getBusinessHolidays(businessId: $businessId) {
      id
      businessId
      holidayId 
      holiday {
        id
        holidayName
        holidayDate 
        requiresAdjustment
        adjustmentRule
        icon
        notes
        countryId  # Only request countryId
      }
    }
  }
`;
